import { TextareaAutosize } from '@material-ui/core';
import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .logo-image': {
      width: '151px !important',
      height: '80px !important',
    },
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
        '& .login-logo-container':{
          '& a img': {
          height: '10% !important',
          }
        }
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
    '& .top-bar-logo-container': {
      height: '40% !important',
    },
    '& .menu-item, .header-phone-link': {
      fontSize: '16px !important',
    },
    '& .topbar-listitem': {
      padding: '0px 10px !important',
    }
  },

  '.group-parent-container': {
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.surface.pricing,
        color: palette.text.footerbg,
        '&:hover': {
          backgroundColor: palette.text.highlight,
          color: palette.surface.pricing,
        },
      },
    },
    '& .normal-text': {
      fontWeight: 400,
      fontFamily: 'Recoleta !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media screen and (max-width: 900px)': {
        fontSize: '50px !important',
        lineHeight: '50px !important',
        letterSpacing: '-1.0px !important',
      },
    },
    '& .hero-home-button': {
      color: palette.text.highlight,
      borderColor: palette.text.highlight,


      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      position: 'relative',
      overflow: 'hidden',
      background: `${palette.primary.light} !important`,
      backgroundSize: 'cover',
      '& .section-header__title-wrapper':{
        paddingTop: '20px !important',
      },
      
      '& .hero-header-title': {
        fontFamily: 'Recoleta !important',
        fontSize: '32px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
        '@media screen and (max-width: 700px)': {
          fontSize: '36px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.64px !important',
        },
      },

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      }
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      position: 'relative',
      backgroundColor: `${palette.background.fill} !important`,
      backgroundSize: 'cover !important',
      /* Recoleta/OpenSauceSans for hero (both variant 1 and 2) */
      '& .hero-title, & .home-hero-title': {
        fontFamily: 'Recoleta',
      },
      '& .hero-subtitle, & .home-hero-subtitle': {
        maxWidth: '480px !important',
        fontFamily: 'OpenSauceSans',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: -1,
        width: '100%',
        height: 'clamp(60px, 8vw, 120px)', // 👈 responsive curve height
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 1920 120' preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0,0 C480,120 1440,120 1920,0 L1920,120 L0,120 Z' fill='white'/%3E%3C/svg%3E")`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        zIndex: 2,
      },

      '& .home-hero-pretitle': {
        '@media(max-width: 900px)': {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },

      '& .hero-background': {
        width: '100% !important',
        height: '100% !important',
        objectFit: 'cover !important',
        objectPosition: 'center center',
        display: 'block',
      },
      '@media (min-width: 1280px) and (max-width: 1510px)': {
        minHeight: '640px !important',
      },
      '@media (min-width: 1024px) and (max-width: 1279px)': {
        minHeight: '500px !important',
        maxHeight: '500px !important',
        '& .hero-background': {
          height: '100% !important',
          objectFit: 'cover !important',
          objectPosition: 'center bottom',
        },
      },


      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,
        
        '& .hero-title, & .home-hero-title': {
          fontFamily: 'Recoleta',
          fontSize: 40,
          fontWeight: '700 !important',
          lineHeight: '55px',
          color: palette.text.highlight,

          '@media(min-width: 678px)': {
            fontSize: '50px !important',
            fontWeight: '500 !important',
            lineHeight: '50px',
          },

          '@media(min-width: 1025px)': {
            fontSize: '64px !important',
            lineHeight: '60px',
            letterSpacing: '-0.04em',
          },
          '@media(max-width: 768px)': {
            maxWidth: 400,
          },
          '@media (min-width: 768px) and (max-width: 900px)': {
            maxWidth: 'none',
            textAlign: 'center',
            fontSize: '56px !important',
            fontWeight: '400 !important',
          },
        },
        '& .hero-subtitle, & .home-hero-subtitle': {
          fontFamily: 'OpenSauceSans',
          color: palette.text.highlight,
          fontWeight: 400,
          fontSize: 18,
          lineHeight: '30px',
          maxWidth: 600,
          '@media(min-width: 767px)': {
            fontSize: 18,
          },
          '@media (min-width: 768px) and (max-width: 900px)': {
            maxWidth: 'none',
            textAlign: 'center',
            fontSize: '18px !important',
            fontWeight: '200 !important',
          }
        },
      },
      '& .section-header':{
        marginTop:'20px !important',
        '@media(max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
        },
      },
      '& .section-header__title-wrapper': {
        '& .home-hero-title': {
          fontWeight: '500 !important',
        },
        maxWidth: '600px !important',
        '@media(max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
        },
        
      },
      '& .image-wrapper': {
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
        '@media(max-width: 1200px)': {
          display: 'flex',
          justifyContent: 'center',
        },
      },
      '@media(min-width: 1025px)': {
        '& .section-alternate__content': {
          paddingTop: 34,
        },
      },
      '@media(max-width: 900px)': {
        '& .hero-title, .hero-subtitle, .home-hero-title, .home-hero-subtitle': {
          textAlign: 'center',
        },
        '& .section-header__cta-wrapper': {
          '& .section-header__cta-container': {
            '& .section-header__cta-item-wrapper': {
              width: '100%',
              '@media (min-width: 768px) and (max-width: 900px)': {
                display: 'flex',
                justifyContent: 'center',
              },
              '@media(max-width: 768px)': {
                display: 'flex',
                justifyContent: 'center',
              },
          }
          }
        }
      },
      '@media (min-width: 768px) and (max-width: 900px)': {
        '& .section-header__cta-wrapper, & .section-header__cta-container': {
          display: 'flex',
          justifyContent: 'center',
        },
        '& .section-header__cta-item-wrapper': {
          width: 'auto !important',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          gap: '16px',
          
        },
        '& .section-header__cta-item-wrapper .MuiButton-fullWidth': {
          width: '170px',
          flex: '0 0 170px',
        },
        '& .section-header__cta-item-wrapper .MuiButton-root': {
          minHeight: '44px',
          padding: '10px 16px',
          fontSize: '16px',
        },
      },
      '@media (min-width: 1024px) and (max-width: 1200px)': {
        '& .section-header': {
          marginTop: '8px !important',
        },
        '& .section-alternate__content': {
          paddingTop: '8px !important',
          fontSize: '16px !important',
        },
        '& .section-header__title': {
          fontSize: '44px !important',
        },
        '& .hero-background': {
          objectFit: 'cover !important',
          objectPosition: 'right !important',
          width: '100% !important',
          height: '100% !important',
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      paddingInline: '40px !important',
      '@media(max-width: 1200px)': {
        padding: '20px !important',
        paddingBottom: '60px !important',
      },
      '& .definition-variant-2': {
        padding: '20px 40px !important',
        '@media screen and (max-width: 1024px) and (min-width: 700px)': {
          padding: '10px 40px !important',
          paddingBottom: '0px !important',
        },
        '@media screen and (max-width: 700px)': {
          padding: '0px 16px !important',
        },
      },
      backgroundColor: palette.text.highlight,
      '& .benefits-wrapper': {
        '& .customImageWrapper': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          left: '-500px',
          '& .image': {
            '@media (min-width: 600px) and (max-width: 1200px)': {
              height: '600px',
              objectFit: 'cover',
            },
          },
        },
      },
      '& .section-alternate__content': {
        padding: '32px 16px',

        '@media (min-width: 600px)': {
          padding: '32px 16px',
        },
        '@media (min-width: 900px)': {
          padding: '40px 48px 40px',
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: 24,

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 24,
      },
      '& .definition-service-title': {
        fontFamily: 'Recoleta',
        fontWeight: 400,
        textAlign: 'left',
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.28px !important',
        paddingBottom: '8px !important',
        '@media screen and (max-width: 1024px) and (min-width: 700px)': {
          fontSize: '28px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
        },
        '@media screen and (max-width: 700px)': {
          fontSize: '24px !important',
          lineHeight: '28px !important',
          letterSpacing: '-1.2px !important',
        },
      },
      '& .customIcon': {
        justifyContent: 'left !important',
        paddingBottom: '40px !important',
      },
      '& .definition-service-description': {
        fontFamily: 'OpenSauceSans',
        color: palette.text.howsubtitle,
        borderBottom: `1px solid ${palette.background.ribbon}`,
        marginBottom: 0,
        textAlign: 'left',
        fontSize: '18px !important',
        lineHeight: '28px !important',
        paddingBottom: '40px !important',
        '@media screen and (max-width: 1024px)': {
          fontSize: '18px !important',
          lineHeight: '28px !important',
        },
      },
      '& .section-header__title': {
        fontFamily: 'Recoleta',
        fontWeight: 500,
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.04px !important',
        color: palette.text.tertiary,
        paddingBottom: '24px !important',
        textAlign: 'left',
        '@media screen and (max-width: 900px)': {
          fontSize: '31px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      position: 'relative',
      backgroundColor: palette.background.pricingbenefits,
      '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-120px',   
      left: 0,
      width: '100%',
      height: '120px',
      backgroundImage:
        'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 1920 120\' preserveAspectRatio=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M0 0.000167852L0 120C0 120 317.5 47.7003 961.5 47.7003C1605.5 47.7002 1920 120 1920 120L1920 0L0 0.000167852Z\' fill=\'%230E7389\'/%3E%3C/svg%3E")',
      backgroundSize: '100% 100%',
      backgroundRepeat: 'no-repeat',
      pointerEvents: 'none',
      zIndex: 3,
    },

      '& .subscription-bg': {
        position: 'relative',
        height: 576,
        background: `url('./images/home-images/pricing-benefits.webp') no-repeat center`,
        backgroundSize: 'cover',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '-2px',
          left: '-2px',
          width: 'calc(100% + 4px)',
          height: '120px',
          backgroundImage:
            'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 1920 120%27 preserveAspectRatio=%27none%27 fill=%27none%27%3E%3Cpath d=%27M0 120L1.04907e-05 3.05125e-05C1.04907e-05 3.05125e-05 317.5 72.2997 961.5 72.2997C1605.5 72.2997 1920 9.91821e-05 1920 9.91821e-05L1920 120L0 120Z%27 fill=%27%230E7389%27/%3E%3C/svg%3E")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'bottom center',
          backgroundSize: '100% 100%',
          pointerEvents: 'none',
          zIndex: 2,
          '@media(max-width: 1200px)': {
            height: '90px',
          },
          '@media(max-width: 768px)': {
            height: '64px',
          },
        },
      },
      '@media(max-width: 900px)': {
        '& .subscription-bg': {
          height: 360,
        },
      },
      '& .section-header__title, .summary-text, .summary-subtext, .subscription-tabs-label':{
        color: `${palette.text.highlight} !important`,
        fontWeight: '500 !important',
      },
      '& .section-header__title': {
        fontWeight: 600,
        fontSize: '48px !important',
        lineHeight: '72px !important',
        letterSpacing: '-1.68px !important',
        whiteSpace: 'pre-line',
        '@media screen and (max-width: 900px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 500,
        fontSize: '18px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        color: palette.text.highlight,
        whiteSpace: 'pre-line',
        '@media screen and (max-width: 700px)': {
          fontSize: '18px !important',
          fontWeight: '400 !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          border: `1.2px solid ${palette.text.primary}`,
          '&:hover': {
            border: `1.2px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
            '& hr': {
              backgroundColor: `${palette.primary.main} !important`,
            },
            '& .MuiButton-root': {
              backgroundColor: `${palette.primary.main} !important`,
              border: `1px solid ${palette.primary.main}`,
              color: `${palette.text.highlight} !important`,
            },
          },
          '& .MuiButton-containedPrimary': {
            backgroundColor: palette.background.primary,
            color: palette.text.tertiary,
            border: `1px solid ${palette.surface.switch}`,
            width: '105% !important',
            '&:hover': {
              backgroundColor: palette.primary.main,
              color: palette.text.highlight,
              transition: 'none !important',
            },
          },
          '& .customcardTitle': {
            fontWeight: 500,
            fontSize: '24px !important',
            lineHeight: '28px !important',
            letterSpacing: '-1.4px !important',
            color: palette.text.footerbg,
          },
          '& .price-value': {
            fontWeight: 600,
            fontSize: '32px !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
            color: palette.text.primary,
            '@media screen and (max-width: 700px)': {
              fontSize: '32px !important',
              lineHeight: '32px !important',
              letterSpacing: '-0.64px !important',
            },
          },
          '& .customUpfrontWrapper': {
            color: palette.text.tertiaryLight,
            fontWeight: 400,
            lineHeight: '16px !important',
            letterSpacing: '-0.42px !important',
            fontStyle: 'italic',
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .bold': {
          fontWeight: 500,
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.secondary} !important`,
          '@media screen and (max-width: 700px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
          },
        },
        '& .summary-text': {
          fontWeight: 500,
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .summary-subtext': {
          fontWeight: 500,
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-summary-link': {
          color: `${palette.text.highlight} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      paddingTop: '100px',
      '& .section': {
        '@media(min-width: 600px)': {
          padding: '40px 64px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        '& .how-it-works-image': {
          borderRadius: 24,
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
          color: palette.text.tertiary,
          fontWeight: 400,
          '@media screen and (max-width: 900px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          color: palette.text.benefitssubtitle,
          '@media screen and (max-width: 900px)': {
            fontSize: '18px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.48px !important',
          },
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .how-cover-image': {
        backgroundSize: 'cover',
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.stepcounter,
        color: palette.secondary.main,
        fontSize: 15,
      },

      '& .working-steps-container': {
        '& .step-title': {
          fontSize: 24,
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          fontWeight: 500,
          color: palette.text.tertiary,
          paddingBottom: '10px !important',
          '@media screen and (max-width: 900px)': {
            fontSize: '22px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.48px !important',
          },
        },
        '& .step-content': {
          fontSize: 18,
          lineHeight: '28px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
          color: palette.text.howsubtitle,
          '@media screen and (max-width: 900px)': {
            fontSize: '18px !important',
            lineHeight: '26px !important',
            letterSpacing: '-0.36px !important',
          },
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 10,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        '& .hero-home-button':{
          backgroundColor: `${palette.primary.contrastText} !important`,
          color: `${palette.text.black} !important`,
          fontSize: '16px !important',
        },
      },
      '& .section-header': {
        '& .hero-header-title': {
          fontSize: '36px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 400,
          '@media screen and (max-width: 900px)': {
            fontSize: '32px !important',
            lineHeight: '36px !important',
            letterSpacing: '-0.64px !important',
          },
        },
        '& .hero-header-subtitle': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.background.primary,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.primary.main} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.highlight,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.primary.light,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .section-alternate': {
        '@media(min-width: 900px)': {
          height: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      '& .hero-static-bg': {
        backgroundColor: `${palette.surface.planCard} !important`,
      },
      '& .section-header__title': {
        color: palette.text.footerbg,
        fontWeight: 400,
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '30px !important',
          lineHeight: '30px !important',
          letterSpacing: '-0.6px !important',
        },
      },
      '& .section-header__subtitle': {
        color: palette.text.footerbg,
        fontWeight: 500,
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
        },
      },
      '& .primary-static-button':{
        backgroundColor: palette.primary.light,
        color: palette.text.highlight,
        borderRadius: '4px !important',
      }
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 400,
      },
      '& .hero-header-subtitle': {
        fontSize: '16px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 500,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    '& .checkout-flow-main-container': {
      '& .card-wrapper': {
        '& .MuiTypography-root, .MuiButton-label': {
          fontSize: '18px !important',
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .MuiButton-contained': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
        fontSize: '16px !important',
      },
      '& .hero-home-button':{
        backgroundColor: `${palette.primary.contrastText} !important`,
          color: `${palette.background.tableHead} !important`,
          fontSize: '16px !important',
      },
      '& .hero-header-title': {
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
        '@media screen and (max-width: 900px)': {
          fontSize: '32px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.64px !important',
        },
      },
      '& .hero-header-subtitle': {
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.4px !important',
        fontWeight: 400,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
          paddingBottom: '0px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
      },
    },
    '& .faq-contact-section': {
      background: `${palette.background.primary} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      color: 'palette.text.tertiary !important',
      '@media screen and (min-width: 1024px)': {
        paddingInline: '0px !important',
      },
      '@media(max-width: 1024px)': {
        paddingInline: '30px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontSize: '32px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
      },
      '& .contact-card-subtitle': {
        fontSize: '18px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
        paddingBottom: '8px !important',
      },
      '& .provider-contact-link': {
        fontSize: '18px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 500,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .MuiGrid-container': {
        padding: '12px',
      },
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.surface.grey,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
        color: palette.surface.light,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.primary.main,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.primary.main, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.primary.main} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      }
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      color: palette.text.highlight,
      '& a': {
        color: palette.text.highlight,
      },
      paddingInline: '80px !important',
      backgroundColor: `${palette.background.footerbackground} !important`,
      '@media(max-width: 900px)': {
        paddingInline: '40px !important',
      },
      '@media(max-width: 500px)': {
        paddingInline: '20px !important',
      },
    },
    '& .success-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: `${palette.text.highlight} !important`,
        color: `${palette.text.black} !important`,
        border: `0.5px solid ${palette.text.black} !important`,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
      },
    },

    '& .header-text': {
      color: palette.primary.light,
      fontWeight: '500 !important',
    },
    '& .checkout-hero-section': {
      height: '250px !important',
      fontSize: '40px !important',
      '& .section-header__title': {
        fontWeight: '500 !important',
      },
    },
    '& .dashboard-main-container': {
      '& .description-cta': {
        backgroundColor: palette.background.loginhome,
      },
    },

    '& .widget': {
      backgroundColor: palette.background.loginhome,
    },
    '& .dashboard-hero-section': {
      height: '250px !important',
      fontSize: '40px !important',
    },

  },
};
